module.exports = __webpack_public_path__ + "static/img/p-title.792fade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/p-title.png
// module id = 3Tsl
// module chunks = 1